export default [
  {
    title: 'breadcrumb.home',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'home',
    action: 'read',
  },
]
